<template>
  <div class="container">
    <div class="car-title">
      <span>全部课程</span>
    </div>
    <div class="content">
      <div v-for="(item, index) in courseList" :key="index" class="item">
        <p v-if="item.time && item.time > 0" class="shi" @click="shibo(item)">
          <img src="@/assets/image/shiting.png" />
          <span>试听</span>
        </p>
        <img :src="item.courseLogo" height="160px" width="100%" alt="" />
        <p>{{ item.courseName }}</p>
        <div class="desc">
          <span>{{ item.courseTeacher }}</span>
          <span>{{ item.courseTypeId }}</span>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <videos ref="videoRef"></videos>
  </div>
</template>

<script>
import api from "../../api";
import videos from "@/components/video.vue";
export default {
  name: "course",
  components: {
    videos,
  },
  data() {
    return {
      courseList: [],
      total: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(page) {
      api.course(1).then((res) => {
        console.log(res);
        res.data.list.forEach((item) => {
          if (item.courseTypeId === 1) {
            item.courseTypeId = "必修";
          }
        });
        // console.log(this.courseList,1111111111)
        this.courseList = res.data.list;
      });
    },
    handleCurrentChange(val) {},
    // 课程试播
    shibo(item) {
      api.getViedeo(item.courseId).then((res) => {
        if (res.data.length > 0) {
          // 设置试听时长和播放时地址
          this.$refs.videoRef.setInit(item.time, res.data[0].videoUrl);
        } else {
          this.$message.error("当前课程暂无视频,无法试听");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto;
  background: #ffffff;
  padding: 20px;
  .item {
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
    padding: 20px 20px 10px;
    position: relative;
    background: RGBA(241, 245, 250, 1);
    box-sizing: border-box;
    border-radius: 6px;
    .shi {
      position: absolute;
      top: 145px;
      right: 20px;
      color: #e9ecef;
      cursor: pointer;
      width: 66px;
      height: 26px;
      background: #a0abb9;
      border-radius: 100px 0px 0px 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin: 0px;
        margin-right: 5px;
      }
    }
    p {
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
      height: 40px;
      margin: 0px 0px 8px;
      display: -webkit-box; /* 使用弹性布局盒子模型 */
      -webkit-line-clamp: 2; /* 设置最多显示3行 */
      -webkit-box-orient: vertical; /* 设置盒模型为垂直方向 */
      overflow: hidden;
    }
    .desc {
      height: 20px;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #dc2326;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.content {
  // display: flex;
  // flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 创建4列 */
  grid-gap: 0 20px; /* 设置列之间的间距（这里指右边距） */
}

.car-title {
  position: relative;
  text-align: left;
  padding-left: 8px;
  height: 22px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #264f99;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
}
.car-title::before {
  content: "";
  width: 4px;
  height: 12px;
  background: #264f99;
  display: block;
  position: absolute;
  top: 6px;
  left: 0px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #264f99;
  color: #264f99;
  background: none;
}
.page {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}
</style>
